import {
  useEffect,
} from 'react';
import classNames from 'classnames';
import {
  EmojiPicker,
} from 'frimousse';
import {
  usePageContext,
} from 'vike-react/usePageContext';
import {
  Modal,
} from '@/components/Modals';
import type {
  ModalProps,
} from '@/components/Modals';
import Button from '@/ui/components/Button';
import {
  ForbidIcon,
} from '@/ui/icons';

import styles from './EmojiModal.module.css';

type EmojiModalProps = ModalProps & {
  onChange?: (emoji: string | null) => void;
}

const EmojiModal = (props: EmojiModalProps) => {
  // ##########################################################################
  // PARAMS
  // ##########################################################################

  const {
    platform,
  } = usePageContext();

  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    isOpen,
    className,
    onChange,
    ...rest
  } = props;

  // ##########################################################################
  // FUNCTIONS
  // ##########################################################################

  const handleChange = ({
    emoji,
  }: {
    emoji?: string
  }) => {
    if (
      !onChange
    ) return;

    if (
      !emoji
    ) return onChange(null);

    onChange(emoji);
  };

  // ##########################################################################
  // EFFECTS
  // ##########################################################################

  useEffect(() => {
    if (
      !isOpen
    ) return;
  }, [isOpen]);

  // ##########################################################################
  // COMPUTED STYLES
  // #########################################################################

  const modalClassName = classNames({
    [styles.emojiModal]: true,
    [styles.ios]: platform === 'ios',
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Modal
      {...rest}
      isOpen={isOpen}
      className={modalClassName}
      allowScrolling
    >
      <EmojiPicker.Root onEmojiSelect={handleChange}>
        <EmojiPicker.Search />

        <EmojiPicker.Viewport className={styles.scrollbar}>
          <EmojiPicker.Loading>Loading…</EmojiPicker.Loading>
          <EmojiPicker.Empty>No emoji found.</EmojiPicker.Empty>

          <div frimousse-category-header="">
            None
          </div>
          <div frimousse-row="">
            <Button
              kind="ghost"
              color="secondary"
              onClick={handleChange}
              className={styles.remove}
              centered
            >
              <ForbidIcon />
            </Button>
          </div>

          <EmojiPicker.List />
        </EmojiPicker.Viewport>
      </EmojiPicker.Root>
    </Modal>
  );
};

export default EmojiModal;
